module.exports = __webpack_public_path__ + "img/konferens.2f23265f.jpg";